import irelandApi from '../irelandApi';

// eslint-disable-next-line import/prefer-default-export
export const getDataExports = () => (dispatch) => {
  dispatch({
    type: 'GET_DATA_EXPORT_LIST_PENDING',
    payLoad: []
  });
  return irelandApi.get('/api/admin/export')
    .then((response) => {
      dispatch({
        type: 'GET_DATA_EXPORT_LIST_FULFILLED',
        payLoad: response.data
      });
    })
    .catch((error) => {
      dispatch({
        type: 'GET_DATA_EXPORT_LIST_REJECTED',
        payLoad: error.data
      });
    });
};
